/**
 * Extension adapters reload the page on `accountsChanged`. When the app itself
 * asks the extension to connect (the secure signing path calls
 * `requestAccounts` for a locked or disconnected extension), that same event
 * fires and the reload kills the flow the user just started. Adapters consult
 * this guard and refresh their stored profile without reloading while it is
 * armed.
 */
let suppressedUntil = 0

export function suppressAccountReload(ms: number): void {
	suppressedUntil = ms > 0 ? Date.now() + ms : 0
}

export function accountReloadSuppressed(): boolean {
	return Date.now() < suppressedUntil
}
